import React from 'react';
import { Tooltip, TooltipProps } from 'antd';

import useTextOverflow from '@/hooks/useTextOverflow';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  rows?: number;
  text: string;
  /** 点击文字 */
  onTextClick?: () => void;
  tooltipPorps?: Partial<TooltipProps>;
}

/**
 * 表格单个单元格长文本处理(需要自己通过样式控制高度才生效)
 */
const LongText: React.FC<IProps> = (props) => {
  const { className, text, onTextClick, rows = 1, style, tooltipPorps } = props;
  const { domRef, isOverflow } = useTextOverflow(rows, text);

  const renderText = () => (
    <div
      className={className}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: rows,
        boxOrient: 'vertical',
        overflow: 'hidden',
        wordBreak: 'break-all',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        ...style,
      }}
      ref={domRef}
      onClick={() => onTextClick?.()}
    >
      {text}
    </div>
  );

  if (isOverflow) {
    return (
      <Tooltip title={text} placement="top" {...tooltipPorps}>
        {renderText()}
      </Tooltip>
    );
  }

  return renderText();
};

export default LongText;
